module.exports = __webpack_public_path__ + "img/02.e1218fad.webp";